<template>
    <button id="FAST_FORWARD" name="FAST_FORWARD" class="btn" data-vcode="FAST_FORWARD">
        <img src="/images/icons/forward.svg" alt="" role="img" aria-hidden="true" />
        <label>{{ $t('fastForward') }}</label>
    </button>
</template>
<script>
export default {};
</script>
